import { Controller } from 'stimulus';
import axios from 'axios';

class CalculateWattageController extends Controller {
  connect() {
    this.element.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') {
        this.submit();
      }
    });
  }

  async submit() {
    this.results = await this.getProducts();

    if (this.results.length === 0) {
      this.resultsTarget.innerHTML = this.renderNoResultsMessage();

      return;
    }

    const results = this.results
      .map(result => this.renderResult(result));

    if (this.hasResultsTarget) {
      const readMoreButtonHtml = this.readMoreButton();
      const resultsHtml = results.length ? (
        `<div class="row row--tight-gutters">
          ${results.join('')}
        </div>`
      ) : '';

      this.resultsTarget.innerHTML = readMoreButtonHtml + resultsHtml;
    }
  }

  getProducts() {
    const length = this.element.elements.namedItem('length').value.replace(',', '.');
    const width = this.element.elements.namedItem('width').value.replace(',', '.');
    const height = this.element.elements.namedItem('height').value.replace(',', '.');
    const isolation = this.element.elements.namedItem('isolation_level').value.replace(',', '.');

    return new Promise((resolve) => {
      axios.get(this.element.getAttribute('data-url'), {
        params: {
          length, height, width, isolation,
        },
      })
        .then((res) => {
          resolve(res.data);
        });
    });
  }

  renderNoResultsMessage() {
    const noProductsFoundMessage = this.element.getAttribute('data-no-products-found-message');
    const phone = this.element.getAttribute('data-phone');
    const email = this.element.getAttribute('data-email');

    return `
      <div class="capped-md mx-auto mt-2">
        <p>${noProductsFoundMessage}</p>

        <div class="d-flex flex-column font-size-md-lg mb-2">
          <a href="tel:${phone}" class="mb-1">
            <svg class="icon icon-phone u-nudge-mb-4" aria-hidden="true">
              <use xlink:href="#icon-phone"></use>
              </svg>
            ${phone}
          </a>

          <a href="mailto:${email}">
            <svg class="icon icon-envelope u-nudge-mb-3" aria-hidden="true">
              <use xlink:href="#icon-envelope"></use>
            </svg>
            ${email}
          </a>
        </div>
      </div>
    `;
  }

  renderResult(product) {
    return `
      <div class="col-md-4 mt-1">
        <div class="product-item js-product bg-white">
          <a href="${product.url}" class="product-item__image" target="_blank">
            <img
              src="${product.image}"
              alt="${product.title}"
              class="img-fluid"
              loading="lazy"
            >
          </a>

          <div class="product-item__body">
            <a
              href="${product.url}"
              class="product-item__title u-color-text font-weight-bold font-size-sm"
              target="_blank"
            >
              ${product.title}
            </a>

            <div class="product-item__price u-color-positive font-weight-bold">
              ${new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(product.price)}
            </div>

            ${this.renderStockable(product)}
          </div>
        </div>
      </div>
    `;
  }

  // eslint-disable-next-line class-methods-use-this
  renderStockable(product) {
    if (!product.is_stockable) {
      return `
        <div class="u-color-negative font-size-sm mt-1-quarter">
          <svg class="icon icon-check u-nudge-mb-2" aria-hidden="true"><use xlink:href="#icon-check"></use></svg>
          Niet op vooraad
        </div>
      `;
    }

    return `
      <div class="u-color-positive font-size-sm mt-1-quarter">
        <svg class="icon icon-check u-nudge-mb-2" aria-hidden="true"><use xlink:href="#icon-check"></use></svg>
        op voorraad
      </div>
    `;
  }

  readMoreButton() {
    const readMoreLink = this.element.getAttribute('data-read-more-link');

    return `
      <a href="${readMoreLink}">
          Lees hier meer informatie over de verschillen tussen de producten
      </a>
    `;
  }
}

CalculateWattageController.targets = [
  'results',
];

export default CalculateWattageController;
